module.exports = __webpack_public_path__ + "static/media/SocialMentions.e84806ba.png";